import { render, staticRenderFns } from "./StatementArchive.vue?vue&type=template&id=7181c186&scoped=true&"
import script from "./StatementArchive.vue?vue&type=script&lang=js&"
export * from "./StatementArchive.vue?vue&type=script&lang=js&"
import style0 from "./StatementArchive.vue?vue&type=style&index=0&id=7181c186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181c186",
  null
  
)

export default component.exports